import { MatDialog } from '@angular/material/dialog';
import { ParametrosConst } from './../../util/parametrosConst';
import {ChangeDetectorRef, Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import {Pregunta} from '../../model/pregunta';
import {Asistente} from '../../model/asistente';
import {Votacion} from '../../model/votacion';
import { UntypedFormControl, UntypedFormArray, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import {AlertaService} from 'src/app/util/alerta.service';
import {VotacionService} from '../votacion.service';
import {Router} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Opcion } from 'src/app/model/opcion';
import { ClienteSesion } from 'src/app/model/cliente-sesion';
import { MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'sura-votacion-edicion',
  templateUrl: './votacion-edicion.component.html',
  styleUrls: ['./votacion-edicion.component.scss']
})
export class VotacionEdicionComponent implements OnInit {
  listaVotacion: Votacion[] = [];
  listaPreguntas: Pregunta[] = [];
  preguntaActual: Pregunta = new Pregunta();
  indicePregActual = 0;
  asistente: Asistente = new Asistente();
  votacionForm: UntypedFormGroup;
  isBtnDisabled = false;
  showFinalizar: Observable<boolean> = of(false);
  showFinalizarB: Observable<boolean> = of(true);
  mostrarDatos = true;
  selectedIndex = 0;
  dataStore: ClienteSesion;
  selectedValue: any;
  @ViewChildren('radioButton') radioButtons: QueryList<MatRadioButton>;

  constructor(private router: Router,
    private _votacionService: VotacionService,
    private alertaService: AlertaService,
    public dialogConfirmar: MatDialog,
    private _formBuilder: UntypedFormBuilder,  private cdr: ChangeDetectorRef) {
      this.votacionForm = this._formBuilder.group({
        votacionArray: this._formBuilder.array([])
    });
  }

  ngOnInit() {

    if(sessionStorage.getItem('votanteactivo') == 'S'){
      const votanteActual = localStorage.getItem('votanteActual');
      let asistenteTemp = this._votacionService.getCurrentUser() || new Asistente;

      if (votanteActual) {
        this.asistente = JSON.parse(votanteActual);
        this.asistente.usuarioRegistro = asistenteTemp.nombres + ' ' + asistenteTemp.apellidos;
      }
    }else{ 

         this.asistente = this._votacionService.getCurrentUser() || new Asistente;
    }
    this.selectedIndex = 0;
    this.obtenerPreguntas();
            
      
    
  }


   obtenerOpcionesPregunta(_pregunta: Pregunta, listaPreguntas: Object, indice: number, idAsamblea: number, idFoto: number) {
    this._votacionService.obtenerOpciones(_pregunta.id, idAsamblea, idFoto).then(
      ops => {
        let voto:'';
        const obj = ops[0];
        const arrayString = obj.descripcion.split(',');
        const arrayOpciones: Opcion[] = [];
        for (let index = 0; index < arrayString.length; index++) {
          const valor = arrayString[index];
          const opcion = new Opcion();
          opcion.descripcion = valor;
          opcion.id = obj.id;
          if(_pregunta.tipoPregunta === 1){
            if(valor === obj.voto){
              opcion.checked = true;
            }
          }else{
            const arrayStringDatos = obj.voto.split(',');
            for(let index2 = 0; index2 < arrayStringDatos.length; index2++){
              if(valor=== arrayStringDatos[index2]){
                opcion.checked = true;
              }
            }          
          }
          arrayOpciones.push(opcion);
        }
        _pregunta.opciones = arrayOpciones;
        _pregunta.mensajePregunta = _pregunta.mensajePregunta.replace('%d', _pregunta.numOpc.toString());
        if (_pregunta.tipoPregunta === 1) {
          this.votacionArray.push(new UntypedFormControl(''));
        } else {
          const checks = new UntypedFormArray([]);
          for (let k = 0; k < _pregunta.opciones.length; k++) {
            checks.push(new UntypedFormControl(false));
          }
          this.votacionArray.push(checks);
        }
        this.listaPreguntas.push(_pregunta);
        this.listaPreguntas.sort((a, b) => a.orden - b.orden);
        const votacion = new Votacion();
        votacion.idOpcion = listaPreguntas[indice].opciones[0].id;
        votacion.voto = obj.voto;
        votacion.idAsamblea = this.asistente.idAsamblea;
        votacion.idFoto = this.asistente.idFoto;
        votacion.idPregunta = listaPreguntas[indice].id;
        votacion.peso = this.asistente.peso;
        votacion.orden = _pregunta.orden;
        if(sessionStorage.getItem('votanteactivo') == 'S'){
          votacion.usuarioRegistro = this.asistente.usuarioRegistro;
        }else{
            votacion.usuarioRegistro = this.asistente.nombres + ' ' + this.asistente.apellidos;
        }
        this.listaVotacion.push(votacion);
        this.listaVotacion.sort((a, b) => a.orden - b.orden);
        this.fnIsDone(0);
        
      }
    ).catch(err => {
      this.alertaService.error(err);
    });
  }
   obtenerPreguntas() {
    this.indicePregActual = 0;
     this._votacionService.obtenerPreguntaActiva(
      this.asistente.idAsamblea,
      this.asistente.id,
      this.asistente.idFoto,
      'H',
      'E'
    )
    .then(listaPreguntas => {
      if (listaPreguntas instanceof Array && listaPreguntas.length === 0) {
        this.alertaService.error('Usted no tiene preguntas por responder');
      } else {
        (listaPreguntas as Array<Pregunta>).forEach((_pregunta, indice) => {

           this.obtenerOpcionesPregunta(_pregunta, listaPreguntas, indice, this.asistente.idAsamblea, this.asistente.idFoto);

         
        });

        if(localStorage.getItem(ParametrosConst.EDICION_VOTO) == 'S'){
          this._votacionService.votacionHistorico(this.asistente.idAsamblea, this.asistente.idFoto).then(r => {
          }).catch(err => {
            this.alertaService.info(err);        
          });
        }

      }
    }).catch(err => {
      this.alertaService.error(err);
    });
  }

  fnIsDone(tabIndex: number) {
    console.log("numero de tabindex:");
    console.log(tabIndex);
    if (tabIndex === null || tabIndex === undefined) {
      return;
    }

    if ((tabIndex + 1) === this.listaPreguntas.length) {
      this.showFinalizar = of(true);
      this.showFinalizarB = of(false);
    } else {
      this.showFinalizar = of(false);
      this.showFinalizarB = of(true);
    }
  }

  enviarVotacion(dato) {
    
    console.log(dato);
    let resultado: Votacion[] = [];
    resultado.push(this.listaVotacion[dato]);
    
    /*const faltanVotos = this.listaVotacion.filter(voto => voto.voto == null).length;
    if (faltanVotos) {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_INCOMPLETO, 'CUIDADO');
    } else {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_COMPLETO, 'CONFIRMAR');
    }*/
   
      this._votacionService.generarVotacionRemota(resultado).then(res => {
        //this.alertaService.success(res);
        //this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
      }).catch(err => {
        this.alertaService.error(err);
      });
      
  }

  enviarVotacionFinal(dato) {
    console.log(dato);
    let resultado: Votacion[] = [];
    resultado.push(this.listaVotacion[dato]);

    /*const faltanVotos = this.listaVotacion.filter(voto => voto.voto == null).length;
    if (faltanVotos) {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_INCOMPLETO, 'CUIDADO');
    } else {
      this.showConfirmarFinalizar(ParametrosConst.MSJ_FINALIZAR_VOTO_COMPLETO, 'CONFIRMAR');
    }*/

      
      this._votacionService.generarVotacionRemota(resultado).then(res => {
        this.alertaService.success(res);
         if(sessionStorage.getItem('votanteactivo') == 'S'){
               const completado = this.verificarVotacionCompleta();
              if(completado){
                this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
                  localStorage.removeItem('votanteActual');
                  localStorage.removeItem('votanteactivo');
                }else{ 
                    this.router.navigate(['/bienvenido']);
                }
          }else{
            this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
          }
      }).catch(err => {
        this.alertaService.error(err);
      });
      
  }

  verificarVotacionCompleta(key: string = 'estadoBienvenida'): boolean {
      try {
        const datosStr = sessionStorage.getItem(key);
        if (!datosStr) return false;
        
        const datos = JSON.parse(datosStr);
        const todosVotantes = [
          ...(datos.votantesPropios || []),
          ...(datos.votantesDelegados || [])
        ];
        
        const votantesQuePuedenVotar = todosVotantes.filter(v => v.puedeVotar === true);
        if (votantesQuePuedenVotar.length === 0) return true;
        return votantesQuePuedenVotar.every(v => v.yaVoto === true);
      } catch {
        return false;
      }
  }

 /*******************************************************************************
  showConfirmarFinalizar(mensaje: string, titulo: string) {
    const confirmDialog: ConfirmDialog = new ConfirmDialog();
    confirmDialog.message = mensaje;
    confirmDialog.submessage = ParametrosConst.MSJ_FINALIZAR_VOTO_NOTA;
    confirmDialog.titulo = titulo;
    confirmDialog.labelOk = 'Finalizar';
    const dialogRef = this.dialogConfirmar.open(ConfirmDialogComponent, {
      width: '500px',
      data: confirmDialog,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (typeof result !== 'undefined' && result.flagRespuesta) {
          this._votacionService.generarVotacionRemota(this.listaVotacion).then(res => {
            this.alertaService.success(res);
            this.router.navigate(['/finVotacion/' + this.asistente.idAsamblea], {skipLocationChange: true});
          }
        ).catch(err => {
          this.alertaService.error(err);
        });
      }
    });
  }
 ****************************************************************************************/
  get votacionArray() {
    return this.votacionForm.get('votacionArray') as UntypedFormArray;
  }

  async clearSelections(index, tabGroup) {
    
    console.log(index);
    // Clear all selections
    /*this.listaPreguntas.forEach(pregunta => {
      pregunta.opciones.forEach(opcion => {
        opcion.checked = false;
      });
    });*/
    this.listaPreguntas[index].opciones.forEach(opcion => {
      opcion.checked = false;      
    });

    this.listaVotacion[index].voto="-1";
    console.log(this.listaVotacion);

    const preguntasBackup = this.listaPreguntas;
    this.listaPreguntas = [];
    this.cdr.detectChanges();

    // Restore the preguntas array to force a full refresh
    setTimeout(() => {
      this.listaPreguntas = preguntasBackup;
      this.cdr.detectChanges();
      tabGroup.selectedIndex = index;
    }, 0);
    
    
  }
  onChangeRadio(event, i) {
    console.log("entrando a editar");
    console.log(i);
    console.log(event);
    console.log(event.source._checked);
    this.listaVotacion[i].voto = event.source.value;
    console.log(this.listaVotacion);
  }

  onChangeCheckBox(event, i) {
    const numOpc = this.listaPreguntas[i].numOpc;
    const voto = this.listaVotacion[i].voto;
    if (event.checked) {
      if (voto != null && voto.split(',').length >= numOpc) {
        this.alertaService.warning('Ya no puede marcar mas opciones');
        event.source.value = false;
        return false;
      } else {
        if (voto != null) {
          const votoFinal = voto.split(',');
          votoFinal.push(event.source.value);
          this.listaVotacion[i].voto = votoFinal.join(',');
        } else {
          this.listaVotacion[i].voto = event.source.value;
        }
      }
    } else {
      const votoFinal = voto.split(',').filter(opc => opc !== event.source.value);
      if (votoFinal.length > 0) {
        this.listaVotacion[i].voto = votoFinal.join(',');
      } else {
        this.listaVotacion[i].voto = null;
      }
    }

    if (this.listaVotacion[i].voto != null && this.listaVotacion[i].voto.split(',').length === numOpc) {
      this.listaPreguntas[i].isDisabled = true;
      this.isBtnDisabled = false;
    } else {
      if (this.listaVotacion[i].voto == null) {
        this.isBtnDisabled = false;
      } else {
        this.isBtnDisabled = true;
      }
      this.listaPreguntas[i].isDisabled = false;
    }
  }

}
